import { MultiAnwerStep, OnceAnwerStep } from '../steps'

export const getWrapperStep = (type: 'multi' | 'once') => {
    if (type === 'once') {
        return OnceAnwerStep
    } else {
        return MultiAnwerStep
    }
}
